/**
 * Capabilities used throughout RSP.
 */
export const JURISDICTION_VIEW = 'jurisdiction_view_0';
export const INTERNATIONAL_SUPPORT = 'international_support_0';
export const ESRI_MAP = 'esri_map_0';

// Alerts
export const ALERTS_FIRE = 'alerts_fire_0';
export const ALERTS_LAW_ENFORCEMENT = 'alerts_law_enforcement_0';
export const ALERTS_MEDICAL = 'alerts_medical_0';
export const ALERTS_ACTIVE_ASSAILANT = 'alerts_active_assailant_0';
export const ALERTS_TRAIN_INCIDENT = 'alerts_train_incident_0';
export const ALERTS_TEST = 'alerts_test_mode_0';

// Spatial Layers
export const _911_INFORM = '_911_inform_2';
export const CRG = 'crg_2';
export const CRG_EXPANDED_MAP_CARD = 'crg_expanded_map_card_0';
export const AVIVE = 'avive';
export const FEATURE_SPATIAL_LAYERS_SUMMARY =
  'feature_spatial_layers_summary_0';

// Agency Share and Chat
export const AGENCY_SHARE_CHAT = 'agency_share_chat_0';

// Alerts Routing
export const ALERTS_NOTIFICATION = 'alerts_notification_0';

// Premium Portal
export const RAPIDSOS_PREMIUM = 'rapidsos_premium_0';

// Agent511 (Text-to-911)
export const AGENT_511_LOCATION = 'agent_511_1';
export const AGENT_511_ADR = 'agent_511_2';

// GIS Services
export const GIS_LAYER_SEARCH = 'gis_layer_search_0';
export const GIS_SEARCH = 'gis_search_0';
export const GIS_SERVICES = 'gis_services_0';

export const AXON = 'axon_3';

// ANI/ALI Partners
export const ALI_GEOCOMM = 'ali_geocomm_1';
export const ALI_INDIGITAL = 'ali_indigital_1';

// ALI lookback: backfill ALI locations missed during a websocket-server outage
export const FEATURE_ALI_LOOKBACK = 'feature_ali_lookback_0';

// Discrepancy Reporting
export const DISCREPANCY_REPORTING = 'discrepancy_reporting_0';

// Call Taker Mode
export const CALL_TAKER_MODE = 'call_taker_mode_0';

// Z-Axis
export const ESTIMATED_FLOOR_LEVELS_GEOCOMM =
  'estimated_floor_levels_geocomm_0';
export const VERTICAL_LOCATION_CONTENT_GEOCOMM =
  'vertical_location_content_geocomm_0';

// map attribution
export const MAP_ATTRIBUTION_GEOCOMM = 'map_attribution_geocomm_0';

// Call Status
export const CALL_STATUS = 'call_status_0';

// Apple ADR
export const APPLE_ADR = 'apple_2';

// Limited Alert Statuses
export const LIMITED_ALERT_STATUSES = 'limited_alert_statuses_0';

// Esri map sketch widget
export const MAP_MARKUP = 'map_markup_0';

// Esri map click to identify
export const CLICK_TO_IDENTIFY = 'click_to_identify_0';

export const TF911 = 'text_from_911_0';
export const TT911 = 'text_to_911_tcapi_0';
export const VT911 = 'video_to_911_0';
export const VT911_CORE = 'video_to_911_core_0';

// EagleView ObliqueImagery
export const EAGLEVIEW = 'eagleview_0';

export const MEDIA_UPLOAD = 'media_upload_0';
export const VIDEO_STREAMING = 'video_streaming_0';
export const DEVICE_MEDIA = 'apple_device_media_2';

export const SECURE911_OSN = 'secure911_0';
export const SECURE911_OSN_ADR = 'secure911_2';

// Communicator bundle Chat, Video, Location Request
export const COMMUNICATOR_VIDEOCALL = 'communicator_videocall_0';
export const COMMUNICATOR_LOCATION_REQUEST = 'communicator_location_request_0';

export const AIR_AMBULANCE = 'air_ambulance_0';
export const AIR_AMBULANCE_STANDBY = 'air_ambulance_standby_0';
export const ROADSIDE_ASSISTANCE = 'roadside_assistance_0';

export const HARMONY_PORTAL_CHAT = 'harmony_portal_chat_0';
// Communicator Full - Transcription
export const COMMUNICATOR_TRANSCRIPTION = 'communicator_transcription_0';

// Communicator | Harmony Transcription, Translation & Playback
export const UNITE_TRANSCRIPTION_AND_AUDIO_PLAYBACK =
  'unite_transcription_and_audio_playback_0';

// Communicator | Harmony Summarization & Keywords
export const UNITE_SUMMARIZATION_AND_KEYWORDS =
  'unite_summarization_and_keywords_0';

// Communicator | Harmony Radio Playback and Transcription
export const UNITE_RADIO_TRANSCRIPTION = 'unite_radio_transcription_0';

// Google RCS
export const GOOGLE_RCS = 'google_rcs_0';

// Communicator | Harmony Video Transcription and Translation
export const HARMONY_VIDEO_TRANSCRIPTION_AND_TRANSLATION =
  'harmony_video_transcription_and_translation_0';

// Communicator - Harmony Text-to-Voice Translation
export const HARMONY_TEXT_TO_VOICE_TRANSLATION =
  'harmony_text_to_voice_translation_0';

// Harmony International Callback
export const HARMONY_INTERNATIONAL_CALLBACK =
  'harmony_international_callback_0';

// Manual Language Selection
export const MANUAL_LANGUAGE_SELECTION = 'manual_language_selection_0';

export const BETA_TEST = 'beta_test_0';

export const VIDEO_TO_911_SHARE_TELNYX = 'video_to_911_share_telnyx_0';

// Admin Line Requests (admin_sms type)
export const ADMIN_LINE_REQUESTS = 'admin_line_requests_0';

// ZeroEyes capability
export const ZEROEYES = 'zeroeyes_2';

// Interagency Chat
export const INTERAGENCY_CHAT = 'interagency_chat_0';

// Collaborator
export const COLLABORATOR_CAPABILITY = 'collaborator_0';

// Pure Wireless (911Locate)
export const PURE_WIRELESS_CAPABILITY = 'pure_wireless_0';

// GIS Layer Category Tabs
export const LAYER_CATEGORY_CAPABILITY = 'layer_category_0';

// Field Sharing
export const FIELD_SHARING = 'field_sharing_0';
export const FIELD_SHARE_IAR = 'field_share_iar_0';
